<!--支付账号信息 -->
<template>
  <div>
    <el-form :rules="rules" :model="submitData" ref="submitData">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="结算方式" prop="PayType" label-width="80px">
              <el-select
                v-model="submitData.PayType"
                placeholder="请选择"
                style="width: 100%"
                :disabled="ReadOnly"
                @change="payTypeChange"
              >
                <el-option
                  v-for="item in payWayList"
                  :key="item.Value"
                  :label="item.Text"
                  :value="item.Value"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6" v-if="isShowBank">
          <div class="grid-content bg-purple">
            <el-form-item label="开户行" prop="Bank" label-width="70px">
              <el-input style="width: 100%" v-model.trim="submitData.Bank"></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6" v-if="isShowAccountName">
          <div class="grid-content bg-purple">
            <el-form-item label="账户名" prop="AccountName" label-width="70px">
              <el-input style="width: 100%" v-model.trim="submitData.AccountName"></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6" v-if="isShowAccount">
          <div class="grid-content bg-purple">
            <el-form-item label="账号" prop="Account" label-width="60px">
              <el-input style="width: 100%" v-model.trim="submitData.Account"></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="备注" label-width="80px">
              <el-input v-model="submitData.Remark"></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="btn-ctn">
      <el-button size="small" class="search-btn" @click="cancel()">取消编辑</el-button>
      <el-button size="small" class="search-btn btn-primary" @click="submitForm()">提交</el-button>
    </div>
    <div>
      <el-table stripe :data="tableData" style="width: 100%;margin-bottom:0px;" empty-text="暂无支付账号数据">
        <el-table-column prop="PayTypeName" label width="85px"></el-table-column>
        <el-table-column label>
          <template slot-scope="scope">{{"账户名："+scope.row.AccountName}}</template>
        </el-table-column>
        <el-table-column label>
          <template slot-scope="scope">{{"账号："+scope.row.Account}}</template>
        </el-table-column>
        <el-table-column label>
          <template slot-scope="scope">{{scope.row.Bank?"开户行："+ scope.row.Bank:""}}</template>
        </el-table-column>
        <el-table-column label prop="Remark" show-overflow-tooltip width="100px"></el-table-column>
        <el-table-column label width="80px" fixed="right">
          <template slot-scope="scope">
            <div class="ops-ctn">
              <el-button title="编辑" size="mini" type="text" @click="editPayAccount(scope.row)">编辑</el-button>
              <el-button
                title="删除"
                size="mini"
                type="text"
                style="color:red"
                @click="delPayAccount(scope.row)"
              >删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: {
    entpCusId: { type: String }
  },
  components: {},
  data() {
    return {
      EntpId: this.$util.getLocalStorage("userMsg").EntpId,
      ReadOnly: false,
      isShowBank: false,
      isShowAccountName: false,
      isShowAccount: false,
      payWayList: [],
      tableData: [],
      submitData: {
        PayType: "",
        EntpCusId: "",
        EntpId: "",
        Remark: "",
        Id: "",
        Bank: "",
        AccountName: "",
        Account: ""
      },
      rules: {
        PayType: [{ required: true, message: "该项必填", trigger: "change" }],
        Account: [{ required: true, message: "该项必填", trigger: "blur" }],
        AccountName: [{ required: true, message: "该项必填", trigger: "blur" }],
        Bank: [{ required: true, message: "该项必填", trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.getPay();
    this.getTableData();
  },
  methods: {
    submitForm() {
      this.submitData.EntpCusId = this.entpCusId;
      this.submitData.EntpId = this.EntpId;

        if (!this.submitData.PayType) {
        this.$util.warningMsg("请选择结算方式");
        return;
      }

      if (this.isShowAccountName&&!this.submitData.AccountName) {
        this.$util.warningMsg("请填写账户名");
        return;
      }
      if (this.isShowAccount&&!this.submitData.Account) {
        this.$util.warningMsg("请填写账号");
        return;
      }

      if (this.submitData.PayType == "30" || this.submitData.PayType == "35") {
        if (!this.submitData.Bank) {
          this.$util.warningMsg("请填写开户行");
          return;
        }
      }

      this.$util
        .axiosPost({
          url: "/api/EntpCustomers/SaveEnterpriseSupplierPayAccounts",
          data: this.submitData
        })
        .then(() => {
          this.$util.successMsg("保存成功");
          this.cancel();
          this.getTableData();
        });
    },
    //  结算方式
    getPay() {
      this.$util.getPay().then(data => {
        if (data) {
          data.forEach(element => {
            if (element.Value > 15) {
              this.payWayList.push(element);
            }
          });
        }
        // this.payWayList = data;
      });
    },
    //结算方式改变事件
    payTypeChange(event) {
      if (event == "20") {
        this.isShowBank = false;
        this.isShowAccountName = true;
        this.isShowAccount = true;
        this.submitData.Bank = "";
      } else if (event == "25") {
        this.isShowBank = false;
        this.isShowAccountName = true;
        this.isShowAccount = true;
        this.submitData.Bank = "";
      } else if (event == "30") {
        this.isShowBank = true;
        this.isShowAccountName = true;
        this.isShowAccount = true;
      } else if (event == "35") {
        this.isShowBank = true;
        this.isShowAccountName = true;
        this.isShowAccount = true;
      } else {
        this.isShowBank = false;
        this.isShowAccountName = false;
        this.isShowAccount = false;
        this.submitData.Bank = "";
        this.submitData.AccountName = "";
        this.submitData.Account = "";
      }
    },
    getTableData() {
      this.$util
        .axiosGet({
          url: "/api/EntpCustomers/GetEnterpriseSupplierPayAccounts",
          data: { EntpCusId: this.entpCusId }
        })
        .then(res => {
          let data = res.data;
          if (!data) data = [];
          this.tableData = data;
        });
    },
    editPayAccount(data) {
      this.submitData.Bank = data.Bank;
      this.submitData.PayType = data.PayType;
      this.submitData.Id = data.Id;
      this.submitData.Remark = data.Remark;
      this.submitData.AccountName = data.AccountName;
      this.submitData.Account = data.Account;
      this.payTypeChange(data.PayType);
    },
    cancel() {
      this.submitData.EntpCusId = "";
      this.submitData.EntpId = "";
      this.submitData.Remark = "";
      this.submitData.Id = "";
      this.submitData.Bank = "";
      this.submitData.AccountName = "";
      this.submitData.Account = "";
       this.$emit("closeDialog");
    },
    delPayAccount(row) {
      if (row) {
        this.$confirm(`确定删除支付账号：${row.AccountName} ?`, "重要提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$util
            .axiosPost({
              url: "/api/EntpCustomers/DelEnterpriseSupplierPayAccounts",
              data: {
                EntpCusId: this.entpCusId,
                PayAccountId: row.Id
              }
            })
            .then(() => {
              this.$util.successMsg("删除成功");
              this.getTableData();
            });
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.dialog-content {
  margin: 5px;
}
.btn-ctn {
  text-align: right;
}
.el-row {
  margin-bottom: 0px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>
